import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  apiRequest,
  errorFormatHandler,
  isDevelop,
} from "../../helpers/apiHelper";

const apiEnv = isDevelop
  ? process.env.REACT_APP_TEST_API_URL
  : process.env.REACT_APP_PUBLIC_API_URL;

export const getMediGroupsRaports = createAsyncThunk(
  "/raports/mediGroups",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest("/raportGrupaMed");
      return responseData;
    } catch (err: any) {
      console.warn("/raports/mediGroups", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getProviderReceptionsRaports = createAsyncThunk(
  "/raports/getProviderReceptionsRaports",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest(
        "/raportReceptiiFurnizor",
      );
      return responseData;
    } catch (err: any) {
      console.warn("/raports/getProviderReceptionsRaports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getNomenclatorCelule = createAsyncThunk(
  "/raports/getNomenclatorCelule",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const { data: responseData } = await apiRequest("/getNomenclatorCelule");
      return responseData;
    } catch (err: any) {
      console.warn("/raports/getNomenclatorCelule", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getUsersActivityReport = createAsyncThunk(
  "/reports/usersActivityReport",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      selectedRoles: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/usersActivityReport`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/usersActivityReport", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getUsersExtraActivities = createAsyncThunk(
  "/reports/usersExtraActivities",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/usersExtraActivities`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/usersExtraActivities", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getReturningProductsToProviderRaports = createAsyncThunk(
  "/reports/returningProductsToProviderRaports",
  async (
    params: {
      page: number;
      per_page: number;
      user: string;
      provider: string;
      dataPV: string;
      docNrAndDate: string;
      productName: string;
      lot: string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/returningProductsToProviderRaports`,
        "GET",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/returningProductsToProviderRaports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadReturningProductsToProviderRaport = createAsyncThunk(
  "/inventory/getDownloadReturningProductsToProviderRaport",
  async (
    {
      idRaport,
      dataPV,
    }: {
      idRaport: string | number | null;
      dataPV: string | null;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window
        .open(
          `${apiEnv}/downloadReturningProductsRaport?idRaport=${idRaport}&dataPV=${dataPV}`,
          "_blank",
        )
        ?.focus();
    } catch (err: any) {
      console.warn(
        "/inventory/getDownloadReturningProductsToProviderRaport",
        err,
      );
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postCollectionErrorsSimplified = createAsyncThunk(
  "/reports/postCollectionErrorsSimplified",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/collectionErrors`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/postCollectionErrorsSimplified", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const postCollectionErrorsDetailed = createAsyncThunk(
  "/reports/postCollectionErrorsDetailed",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers: number[];
      month: number;
      year: number;
      day: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/collectionErrorsDetailed`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/postCollectionErrorsDetailed", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getMonthActivityWmsReports = createAsyncThunk(
  "/reports/getMonthActivityWmsReports",
  async (
    params: {
      page: number;
      per_page: number;
      selectedUsers?: number[];
      selectedRoles?: number[];
      month: number;
      year: number;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { data: responseData } = await apiRequest(
        `/getMonthActivityWmsReports`,
        "POST",
        params,
      );
      return responseData;
    } catch (err: any) {
      console.warn("/reports/getMonthActivityWmsReports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);

export const getDownloadMonthActivityReports = createAsyncThunk(
  "/admin/getDownloadMonthActivityReports",
  async (
    {
      month,
      year,
    }: {
      month: number | string;
      year: number | string;
    },
    { rejectWithValue, dispatch },
  ) => {
    try {
      window
        .open(
          `${apiEnv}/exportMonthActivityWmsReports/${month}/${year}`,
          "_blank",
        )
        ?.focus();
    } catch (err: any) {
      console.warn("/admin/getDownloadMonthActivityReports", err);
      return rejectWithValue(errorFormatHandler(err, dispatch));
    }
  },
);
